import * as RouteUtils from '../lib/RouteUtils';

export function navigateToLogin(): void {
  location.href = RouteUtils.getLoginPath();
}

export function navigateToRoot(): void {
  location.href = RouteUtils.getRootPath();
}
